import {customAlphabet} from 'nanoid'
const nanoidSet = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890', 12)
export {nanoidSet}